import {
  CandidateBuilder,
  GetCandidateDeletionPermissionOutput,
} from '../candidates.types';

// Whether the logged-in internal user may delete candidates; the backend owns the list.
export const getCandidateDeletionPermission = (builder: CandidateBuilder) =>
  builder.query<GetCandidateDeletionPermissionOutput, void>({
    query: () => ({
      url: '/candidates/deletion-permission',
      method: 'GET',
    }),
  });
